import React from 'react';

import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { formatDateAndTimeShort, fromUtc } from '@app/services/date';

interface IProps {
  deactivatedAt?: string | null;
  byCustomer?: boolean;
}

export const DeactivatedTag: React.FC<IProps> = ({ deactivatedAt, byCustomer }) => {
  const warehousesT = useTranslation(NSKeys.warehouses);

  if (!deactivatedAt) {
    return null;
  }

  const date = formatDateAndTimeShort(fromUtc(deactivatedAt));

  return (
    <Tag color="error">
      {byCustomer ? warehousesT.t('deactivatedByCustomer', { date }) : warehousesT.t('deactivated', { date })}
    </Tag>
  );
};
